import { GreetingsCardsErrorType } from 'components/PDP/Order/GreetingsCards/enums/greetings-cards-error-type.enum';

export const isFreeCardMessageError = (
  error: GreetingsCardsErrorType,
): boolean =>
  error === GreetingsCardsErrorType.LINES_LIMIT_EXCEED ||
  error === GreetingsCardsErrorType.CHAR_LIMIT_EXCEED ||
  error === GreetingsCardsErrorType.SPL_CHARS_ENTERED ||
  error === GreetingsCardsErrorType.EMOJIS_ENTERED;
